import { createContext } from 'react';

const TabletContext = createContext(false);

export default TabletContext;
